import InfoModal from "../../../components/InfoModal";
import { getDate } from "../../../helpers/dateHelper";

export default function DemoRescheduleInfoPopup({ data, setModal }) {
  const demoHistory = data?.demoInfo || [];

  const formatDemoDate = (dateStr) => {
    if (!dateStr) return "-";
    try {
      return getDate(dateStr);
    } catch {
      return dateStr;
    }
  };

  return (
    <InfoModal setModal={setModal}>
      <div className="info-popup-header">
        <div>
          <p className="r-text m-weight f-op caps">Demo reschedule history</p>
          <p className="xxs-text m-weight q-op uppercase">
            {data?.customer?.firstName} {data?.customer?.lastName}
            {data?.enquiry?.enquiryId ? ` · ${data.enquiry.enquiryId}` : ""}
          </p>
        </div>
      </div>
      <div style={{ padding: "16px 24px" }}>
        {demoHistory.length === 0 ? (
          <p className="xxs-text h-op">No demo history available.</p>
        ) : (
          demoHistory.map((item, index) => (
            <div key={item._id || index} className="demo-detail-list-item mb-md">
              <div className="flex-between header-flex mb-xs">
                <p className="xxxs-text m-weight h-op">#{index + 1}</p>
                {item.rescheduledReason ? (
                  <p className="xxxs-text m-weight h-op rescheduled-badge">{item.tutorRescheduled ? 'Tutor Rescheduled' : 'Client Rescheduled'}</p>
                ) : null}
              </div>
              <div className="demo-info-sub-item">
                <div className="mb-xs">
                  <label>Date &amp; time</label>
                  <p className="xxs-text m-weight f-op">
                    {formatDemoDate(item.demoDate)} · {item.demoTime || "-"}
                  </p>
                </div>
                {item.rescheduledReason ? (
                  <div>
                    <label>Reason</label>
                    <p className="xxs-text r-weight f-op">{item.rescheduledReason}</p>
                  </div>
                ) : null}
              </div>
            </div>
          ))
        )}
      </div>
    </InfoModal>
  );
}
